// Enabler E7-C (ADO-2274), D-16: the "Picked fresh" pill: the design system's "InStockPill"
// component, variant stock="Picked fresh" (Figma file nRZ4PP9StRckpuliV9HEG1, node 7298:215034).
// A leading Leaf and the label on the sage tint, no status dot. It states that a product has no
// stock level to show (picked fresh, always orderable), so it is not a StatusBadge tone: that
// primitive's geometry (2px 10px padding, 600 weight, 6px gap) is not this component's.
//
// a11y: the label text carries the meaning; the leaf is decorative (aria-hidden).

import type { ReactNode } from 'react';
import { Icon } from '../Icon/Icon';
import styles from './PickedFreshPill.module.css';

export interface PickedFreshPillProps {
  /** The visible label, the caller's copy ("Picked fresh"). */
  children: ReactNode;
}

export function PickedFreshPill({ children }: PickedFreshPillProps) {
  return (
    <span className={styles.pill}>
      <Icon name="leaf" size={12} className={styles.leaf} />
      {children}
    </span>
  );
}
